var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkerOnlineAssetHasDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.8395C0 8.5393 7.5393 1 16.8395 1C26.1397 1 33.679 8.5393 33.679 17.8395C33.679 27.1397 26.1397 34.679 16.8395 34.679C7.5393 34.679 0 27.1397 0 17.8395Z",
    fill: "#3BDC65",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7 8.2C22.5 6.1 19.8 5 16.9 5C13.9 5 11.3 6.1 9.09995 8.2C6.79995 10.3 5.69995 13.1 5.69995 16.3C5.69995 18.7 6.59995 21.2 8.29995 23.7C9.89995 26 12.3 28.5 15.6 31.2L16.9 32.3L18.2 31.2C21.4 28.5 23.9 26 25.5 23.7C27.2 21.2 28.1 18.7 28.1 16.3C28 13.1 26.9 10.3 24.7 8.2ZM23.8 22.6C22.3 24.8 20 27.1 16.9 29.7C13.8 27.1 11.5 24.8 9.99995 22.6C8.49995 20.4 7.69995 18.3 7.69995 16.3C7.69995 13.6 8.59995 11.3 10.4 9.6C12.2 7.9 14.4 7 16.9 7C19.4 7 21.5 7.9 23.3 9.6C25.1 11.3 26 13.6 26 16.3C26 18.3 25.3 20.4 23.8 22.6Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3 9.6C21.5 7.9 19.3 7 16.9 7C14.4 7 12.2 7.9 10.4 9.6C8.59995 11.4 7.69995 13.6 7.69995 16.3C7.69995 18.3 8.49995 20.4 9.99995 22.5C11.5 24.6 13.8 27 16.9 29.6C20 27 22.3 24.7 23.8 22.5C25.3 20.3 26.1 18.2 26.1 16.3C26 13.6 25.1 11.4 23.3 9.6Z",
    fill: "#3BDC65"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8999 18.1992C17.3999 18.1992 17.8999 17.9992 18.2999 17.5992C18.6999 17.1992 18.8999 16.7992 18.8999 16.1992C18.8999 15.6992 18.6999 15.1992 18.2999 14.7992C17.8999 14.3992 17.4999 14.1992 16.8999 14.1992C16.3999 14.1992 15.8999 14.3992 15.4999 14.7992C15.0999 15.1992 14.8999 15.6992 14.8999 16.1992C14.8999 16.6992 15.0999 17.1992 15.4999 17.5992C15.8999 17.9992 16.2999 18.1992 16.8999 18.1992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerOnlineAssetHasDevice);
export default __webpack_public_path__ + "static/media/marker_online_asset_has_device.5a94d919374868f740c2b14db368ba95.svg";
export { ForwardRef as ReactComponent };